import { Button } from '@cmsgov/ds-medicare-gov';
import { usePageView } from '../../common/hooks/use.analytics';
import Form from './Form';
import Div from '../../common/components/div';
import TranslatedSpan from '../../common/components/TranslatedSpan';
import Local from '../../common/classes/local';
import { useAuthenticatedRedirect } from '../../common/hooks/useAuthenticatedRedirect';
import { useHistory, useLocation } from 'react-router';
import { useEffect, useState } from 'react';
import translate from '../../common/functions/translate';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LoginMaintenance } from './LoginMaintenance';

export const LOGIN_QUERY_STRING_KEY = 'loginQueryString';
interface LoginProps {
    location?: { state?: { showAlreadyUnlockedAlert?: boolean }}
}

export default function Login(props:LoginProps) {
    usePageView('Login');

    const { showMaintenancePageLogin } = useFlags();

    useAuthenticatedRedirect();
    const location = useLocation();
    const history = useHistory();

    const currentQueryString = location.search;

    // keep login query params throughout session
    useEffect(() => {
        // don't save error param
        const params = new URLSearchParams(currentQueryString);
        const newQueryString = params.toString() ? `?${params.toString()}` : '';

        const savedQuery = sessionStorage.getItem(LOGIN_QUERY_STRING_KEY);
        if (savedQuery && !newQueryString) {
            history.replace('/login' + savedQuery);
        } else {
            sessionStorage.setItem(LOGIN_QUERY_STRING_KEY, newQueryString);
        }
    }, [currentQueryString, history]);

    const getCoronavirusSubdomain = (Local.getItem('language') === 'English') ? 'www' : 'es';

    const [covidLinkRef, setCovidLinkRef] = useState<HTMLAnchorElement | null>(null);
    useEffect(() => {
        if (covidLinkRef) {
            covidLinkRef.rel = 'noopener noreferrer';
            covidLinkRef.target = '_blank';
        }
    }, [covidLinkRef]);

    return (
        <>
            <div className={"ds-u-fill--primary-alt"}>
                <Div isContainer>
                    <Div isRow>
                        <Div cols={12} paddingx={7} paddingy={5}>
                            <Div
                                paddingRight={1}
                                paddingRightMD={7}
                                className={
                                    "ds-u-color--white ds-u-display--inline-block ds-text-heading--xl ds-u-margin-bottom--0"
                                }
                            >
                                {translate(
                                    "see_how_medicare_responding_to_coronavirus"
                                )}
                            </Div>
                            <Button
                                className={"ds-u-padding-x--7"}
                                href={`https://${getCoronavirusSubdomain}.medicare.gov/medicare-coronavirus`}
                                inputRef={setCovidLinkRef}
                            >
                                <TranslatedSpan english={"learn_more"} />
                                <span
                                    className={"ds-u-visibility--screen-reader"}
                                >
                                    <TranslatedSpan
                                        english={"this_link_open_window"}
                                    />
                                </span>
                            </Button>
                        </Div>
                    </Div>
                </Div>
            </div>
            {showMaintenancePageLogin ? (
                <LoginMaintenance />
            ) : (
                <Form
                    showAlreadyUnlockedAlert={
                        props.location?.state?.showAlreadyUnlockedAlert
                    }
                />
            )}
        </>
    );
}
